export default __webpack_public_path__ + "static/media/06.45501f22.jpg";